import { useContext, useState } from "react";
import ToastContext from "../../context/toastProvider";
import Modal from "../utils/modal";
import { describePath, formatDiffValue } from "./pricingDiffFormat";

const PublishConfirmModal = ({ diff = [], publish, onClose }) => {
    const { goodToast, badToast } = useContext(ToastContext);
    const [note, setNote] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handlePublish = async () => {
        setSubmitting(true);
        const response = await publish(note);
        setSubmitting(false);
        if (response?.type === "success") {
            goodToast("Nova versão publicada — vale em até 30s");
            onClose?.();
        } else {
            badToast(response?.message || "Erro ao publicar configuração.");
        }
    };

    return (
        <Modal width="600px">
            <div className="p-4 text-left text-primary">
                <h2 className="mb-3 text-xl font-semibold text-[#d59106]">Confirmar publicação</h2>

                {diff.length > 0 ? (
                    <div className="mb-4 max-h-64 overflow-y-auto rounded border border-[#d59106]/40">
                        <table className="min-w-full divide-y divide-[#d59106]/40 text-left text-sm">
                            <thead className="bg-[#111] text-[#d59106]">
                                <tr>
                                    <th className="px-3 py-2">Campo</th>
                                    <th className="px-3 py-2">Antes</th>
                                    <th className="px-3 py-2">Depois</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-[#d59106]/20">
                                {diff.map((entry) => (
                                    <tr key={entry.path}>
                                        <td className="px-3 py-2">{describePath(entry.path)}</td>
                                        <td className="px-3 py-2">{formatDiffValue(entry.path, entry.before)}</td>
                                        <td className="px-3 py-2">{formatDiffValue(entry.path, entry.after)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="mb-4 text-sm text-primary/70">Nenhuma alteração pendente.</p>
                )}

                <label className="mb-4 block text-sm font-semibold text-primary">
                    Nota (opcional)
                    <textarea
                        className="mt-1 w-full rounded border border-primary/50 bg-black px-2 py-1 text-primary outline-none focus:border-primary"
                        value={note}
                        onChange={(event) => setNote(event.target.value)}
                        placeholder="Ex.: reajuste de tabela de agosto"
                    />
                </label>

                <div className="flex justify-end gap-3">
                    <button
                        type="button"
                        className="rounded bg-red-600 px-4 py-2 font-semibold text-white hover:bg-red-500"
                        onClick={onClose}
                        disabled={submitting}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="rounded bg-[#d59106] px-4 py-2 font-semibold text-black hover:bg-[#b47c06] disabled:cursor-not-allowed disabled:opacity-50"
                        onClick={handlePublish}
                        disabled={submitting}
                    >
                        {submitting ? "Publicando..." : "Publicar"}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PublishConfirmModal;
